import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=da0ecbe2&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=da0ecbe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0ecbe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da0ecbe2')) {
      api.createRecord('da0ecbe2', component.options)
    } else {
      api.reload('da0ecbe2', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=da0ecbe2&scoped=true&", function () {
      api.rerender('da0ecbe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C5LnIT3WcwM9/JS/comp/PopupBox.vue"
export default component.exports